import {
  displayStatus,
  formatIST,
  getThemeColor,
  pretty,
} from "../utils";

export default function LeadHeader({
  lead,
  canDial,
  scheduledAction,
  isNotReachable,
}) {
  const phone =
    lead.leadDetails?.phone;

  

  return (
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className={`text-xs mb-2 px-5 py-2 border rounded-lg ${getThemeColor(lead.leadDetails?.leadVariant)}`}>
           New Goa Lead - {lead.leadDetails?.leadScore || 0 } <span className="uppercase">({lead.leadDetails?.leadVariant || "Hot"})</span>
        </p>

        <h1 className="truncate text-lg font-bold capitalize">
          {lead.leadDetails?.name ||
            "Unknown Lead"}  ·  #{lead.leadId}
        </h1>

        <div className="mt-1 flex flex-wrap items-center gap-1.5">
          <span className="rounded-full bg-slate-900 px-2 py-0.5 text-[10px] font-semibold text-white">
            {isNotReachable
              ? "Not Reachable"
              : displayStatus(
                  lead.currentStatus
                )}
          </span>

          <span className="text-[11px] text-slate-400">
            {pretty(lead.level)}
          </span>
        </div>

        {scheduledAction.exists &&
          !scheduledAction.active && (
            <p className="mt-1.5 text-[10px] font-medium text-amber-600">
              {scheduledAction.before
                ? `Scheduled: ${formatIST(
                    scheduledAction.date
                  )} IST`
                : `Missed: ${formatIST(
                    scheduledAction.date
                  )} IST`}
            </p>
          )}
      </div>

      {phone &&
        (canDial ? (
          <a
            href={`tel:${phone}`}
            className="shrink-0 rounded-lg bg-slate-900 px-3 py-2 text-xs font-semibold text-white"
          >
            Dial
          </a>
        ) : (
          <button
            type="button"
            disabled
            className="shrink-0 cursor-not-allowed rounded-lg bg-slate-200 px-3 py-2 text-xs font-semibold text-slate-400"
          >
            Dial
          </button>
        ))}
    </div>
  );
}